import { z } from 'zod';

export const UserSchema = z.object({
	createdAt: z.int(),
	createdBy: z.uuidv4().nullable(),
	defaultAccount: z.uuidv4().nullable(),
	email: z.email(),
	grantType: z.string(),
	id: z.uuidv4(),
	isFederated: z.boolean(),
	name: z.string().nullable(),
	permissionCodes: z.array(z.string()),
	status: z.string(),
	updatedAt: z.int(),
	updatedBy: z.uuidv4().nullable(),
	version: z.int().min(1),
});

export const UsersSchema = z.array(UserSchema);

export type IUser = z.infer<typeof UserSchema>;
export type IUsers = z.infer<typeof UsersSchema>;
